export default __webpack_public_path__ + "static/media/ID78.b18e278d.png";